import { Component } from '@angular/core';

@Component({
  selector: 'ui-navbar',
  templateUrl: './navbar.component.html'
})
export class NavBarComponent {
}